{
  "assetContainerEvent": {
    "types": {
      "arrived": "도착함",
      "arrivedWaiting": "도착/대기 중",
      "loading": "상차 중",
      "loadingComplete": "상차 완료",
      "unloading": "하차 중",
      "unloadingComplete": "하차 완료",
      "readyForPickup": "픽업 준비 완료",
      "departed": "출발함",
      "inoperable": "작동 불가",
      "missing": "분실",
      "inTransit": "이동 중"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "도착함",
    "Docked": "도킹됨",
    "Parked": "주차됨",
    "Unassigned": "미배정",
    "Dropped": "분리됨",
    "Hooked": "연결됨",
    "Appointment Linked": "예약 연결됨",
    "Appointment Unlinked": "예약 연결 해제됨",
    "Status Updated": "상태 업데이트"
  },
  "assetContainerTypes": {
    "trailer": "트레일러",
    "container": "컨테이너",
    "oversized": "특대형",
    "chassis": "섀시",
    "reefer": "냉동 트레일러",
    "other": "기타"
  },
  "assetVisitTypes": {
    "live": "현장 상하차",
    "drop": "드롭(분리)",
    "pickup": "훅(연결)",
    "dropHook": "드롭 및 훅"
  },
  "assetVisitDirections": {
    "inbound": "입고",
    "outbound": "출고",
    "inboundAndOutbound": "입고 및 출고"
  },
  "loadTypeDirections": {
    "inbound": "입고",
    "outbound": "출고",
    "inOut": "입고 & 출고"
  },
  "altAssetVisitTypes": {
    "unknown": "알 수 없음"
  },
  "assetContainerStates": {
    "full": "적재",
    "empty": "공차",
    "partiallyLoaded": "부분 적재"
  },
  "spotStatuses": {
    "open": "열림",
    "closed": "닫힘",
    "assigned": "배정됨",
    "inTransit": "이동 중",
    "reservedManual": "예약됨",
    "reservedAutomated": "예약됨",
    "unknown": "알 수 없음"
  },
  "spotTypes": {
    "parking": "주차",
    "docking": "도킹"
  },
  "labels": {
    "licensePlate": "번호판",
    "dotNumber": "DOT 번호"
  },
  "messages": {
    "unknownCompany": "알 수 없는 회사",
    "unhooked": "연결 해제됨",
    "noInformationAvailable": "사용 가능한 정보 없음",
    "noVisitFound": "방문을 찾을 수 없음",
    "notInformed": "입력되지 않음",
    "waitingAssignment": "배정 대기 중",
    "failedToLoadSpotDetails": "스팟 세부 정보를 불러오지 못했습니다",
    "retry": "다시 시도",
    "blockedUntilSpotIsOpen": "{spot}이(가) 열릴 때까지 차단됨",
    "blockReasons": {
      "reservedByOther": "목적지 스팟이 **이동 작업 #{taskNumber}**에 **예약되어** 있습니다.",
      "reservedByOtherGeneric": "목적지 스팟이 **예약되어** 있습니다.",
      "destinationClosed": "목적지 스팟이 **닫혀** 있습니다.",
      "destinationOccupied": "목적지 스팟을 다른 자산이 **사용 중**입니다.",
      "anotherAssetInTransitForDestination": "**{assetCode}**이(가) 이미 이 스팟으로 이동 중입니다.",
      "assetInTransitElsewhere": "자산이 이미 다른 이동 작업으로 이동 중입니다."
    }
  }
}
